import React, { useEffect, useRef, useState } from 'react';
import './MoreBtn.scss';
import { Button } from 'primereact/button';
import CustomTooltip from '../tooltip/CustomTooltip';
import { Menu } from 'primereact/menu';

interface MoreBtnProps {
  children: React.ReactNode;
  rowId: number;
}

const MoreBtn: React.FC<MoreBtnProps> = ({ children, rowId }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<Menu>(null);

  const toggleMenu = (event: any) => {
    setIsMenuOpen(!isMenuOpen);

    if (menuRef.current) {
      menuRef.current.toggle(event);
    }
  };

  const handleScroll = () => {
    if (menuRef.current) {
      menuRef.current.hide({} as React.SyntheticEvent);
    }
  };

  useEffect(() => {
    const layoutElement = document.querySelector('.layout__right');
    if (layoutElement) {
      layoutElement.addEventListener('scroll', handleScroll);

      return () => {
        layoutElement.removeEventListener('scroll', handleScroll);
      };
    }
  }, [isMenuOpen]);

  return (
    <div className="more-action">
      <Button id={`more-btn-${rowId}`} className="action-btn action-btn--more" onClick={toggleMenu}>
        <span className="ico--more ico--xs" />
      </Button>
      <CustomTooltip tooltipText="viewDetails" targetRef={`more-btn-${rowId}`} />
      <Menu
        ref={menuRef}
        model={[{ template: children }]}
        popup
        appendTo={document.body}
        popupAlignment="right"
        onHide={() => setIsMenuOpen(false)}
      />
    </div>
  );
};

export default MoreBtn;
